import React from "react";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { createCustomColumns } from "./CustomColumnsConfig";
import { CustomSideFilter } from "./CustomSideFilter";
import SaleSupportForm from "./SaleSupportForm";
import SaleSupportModals from "./SaleSupportModals";
import { useSaleSupportFranchiseLogic } from "./useSaleSupportFranchiseLogic";
import { SaleSupportType } from "../types/index";
import { useSnapshot } from "valtio";
import {
    store as storeSaleSupport,
    setFranchiseDataIsUpdated,
    setIsHistoryModalOpened,
    setIsInlineErrorCleared,
    setIsActionsClicked,
    setIsEdited,
} from "../store";
import { store as StoreConfirmationActivationDeactivation } from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import { useAuthHeader } from "../../../../api/headersKeycloak";
import ModalLoading from "@components/Common/ModalLoading";
import { t } from "i18next";

export default function SaleSupportFranchise({
    isArchivedSaleSupportClicked,
    setIsArchivedSaleSupportClicked,
    setLimit,
}: SaleSupportType) {
    const getAuthHeader = useAuthHeader();
    const {
        isHistoryModalOpened,
        isActionsClicked,
        actions,
        validationAction,
        isEdited,
        isLoading,
        key,
    } = useSnapshot(storeSaleSupport);
    const { activationDeactivationMessageModalOpened } = useSnapshot(
        StoreConfirmationActivationDeactivation
    );
    const [SalesModesTypesAndTag, setSalesModesTypesAndTag] = React.useState<
        any
    >({});
    const {
        url,
        userData,
        i18nextLng,
        oneShop,
        data,
        setData,
        saleSupport,
        setSaleSupport,
        filterActive,
        setLocalFilterActive,
        isAddSaleSupportClicked,
        setIsAddSaleSupportClicked,
        selectedRows,
        setSelectedRows,
        franchiseDataIsUpdated,
        isConsult,
        setIsConsult,
        dataState,
        rowData,
        setRowData,
        setDataState,
        isAddNewSaleSupportButtonClicked,
        setIsAddNewSaleSupportButtonClicked,
        isModalConfirmationOpened,
        setIsModalConfirmationOpened,
        isFavoriteModified,
        setIsFavoriteModified,
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    } = useSaleSupportFranchiseLogic(isArchivedSaleSupportClicked);

    const columns = createCustomColumns({
        setLimit,
        userData,
        setSaleSupport,
        setIsAddSaleSupportClicked,
        setIsModalConfirmationOpened,
        isModalConfirmationOpened,
        setSelectedRows,
        isArchivedSaleSupportClicked,
        isFavoriteModified,
        setIsFavoriteModified,
        setRowData,
        setIsConsult,
        setDataState,
        setSalesModesTypesAndTag,
    });

    return (
        <>
            <div
                style={{
                    display: "grid",
                    minHeight: oneShop ? "650px" : "600px",
                    gridTemplateColumns: isAddSaleSupportClicked
                        ? "2fr 1fr"
                        : "auto",
                    gridColumnGap: "4px",
                }}
            >
                <DynamicTable
                    key={key}
                    url={url}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    canExpand={false}
                    canSelect
                    canResize
                    setData={setData}
                    customSelect
                    canMovedCheckboxLeftOnExpand
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setLimit={setLimit}
                            selectedRows={selectedRows}
                            saleSupport={saleSupport}
                            isEdited={isEdited}
                            setIsInInitializationModalOpened={
                                setIsInInitializationModalOpened
                            }
                            setLocalFilterActive={setLocalFilterActive}
                            setIsAddSaleSupportClicked={
                                setIsAddSaleSupportClicked
                            }
                            isAddSaleSupportClicked={isAddSaleSupportClicked}
                            setIsModalConfirmationOpened={
                                setIsModalConfirmationOpened
                            }
                            isModalConfirmationOpened={
                                isModalConfirmationOpened
                            }
                            isArchivedSaleSupportClicked={
                                isArchivedSaleSupportClicked
                            }
                            setIsArchivedSaleSupportClicked={
                                setIsArchivedSaleSupportClicked
                            }
                            setSalesModesTypesAndTag={setSalesModesTypesAndTag}
                        />
                    }
                    showGlobalFilter
                    showFilter
                    actionColumn={() => <></>}
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    arrayOfCustomColumns={columns}
                    setDataIsUpdated={
                        setFranchiseDataIsUpdated as
                            | React.Dispatch<
                                  React.SetStateAction<number | boolean>
                              >
                            | undefined
                    }
                    dataIsUpdated={franchiseDataIsUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="saleSupport"
                />
                {isAddSaleSupportClicked && (
                    <SaleSupportForm
                        setLimit={setLimit}
                        allDataShops={
                            data?.othersData !== undefined &&
                            !isArchivedSaleSupportClicked
                                ? data?.othersData?.allData?.data
                                : []
                        }
                        isAddSaleSupportClicked={isAddSaleSupportClicked}
                        setIsAddSaleSupportClicked={setIsAddSaleSupportClicked!}
                        saleSupport={saleSupport}
                        isAddNewSaleSupportButtonClicked={
                            isAddNewSaleSupportButtonClicked
                        }
                        setSaleSupportData={setSaleSupport}
                        userData={userData}
                        setLocalFilterActive={setLocalFilterActive}
                        setIsConsult={setIsConsult}
                        isConsult={isConsult}
                        dataState={dataState}
                        SalesModesTypesAndTag={SalesModesTypesAndTag}
                        setSalesModesTypesAndTag={setSalesModesTypesAndTag}
                    />
                )}
            </div>
            <SaleSupportModals
                isInInitializationModalOpened={isInInitializationModalOpened}
                setIsInInitializationModalOpened={
                    setIsInInitializationModalOpened
                }
                isAddNewSaleSupportButtonClicked={
                    isAddNewSaleSupportButtonClicked
                }
                setIsAddNewSaleSupportButtonClicked={
                    setIsAddNewSaleSupportButtonClicked
                }
                setIsEdited={setIsEdited}
                setIsInlineErrorCleared={setIsInlineErrorCleared}
                isHistoryModalOpened={isHistoryModalOpened}
                setIsHistoryModalOpened={setIsHistoryModalOpened}
                selectedRows={selectedRows}
                isModalConfirmationOpened={isModalConfirmationOpened}
                setIsModalConfirmationOpened={setIsModalConfirmationOpened}
                setFranchiseDataIsUpdated={setFranchiseDataIsUpdated}
                isFavoriteModified={isFavoriteModified}
                setIsFavoriteModified={setIsFavoriteModified}
                rowData={rowData}
                isActionsClicked={isActionsClicked}
                setIsActionsClicked={setIsActionsClicked}
                validationAction={validationAction}
                actions={actions}
                activationDeactivationMessageModalOpened={
                    activationDeactivationMessageModalOpened
                }
                oneShop={oneShop}
            />
            {isLoading && (
                <ModalLoading
                    isOpen={isLoading}
                    data={{
                        title: t("Alert"),
                        message: t("The action is currently being processed."),
                    }}
                />
            )}
        </>
    );
}
